<div class="preview-dialog">
  <div class="preview-header">
    <div class="file-info">
      <span class="file-name">{{ displayFileName }}</span>
      <span class="file-type-badge">{{ data.fileType }}</span>
    </div>
    <button class="close-btn" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="preview-content">
    @if (loading && isPdfOrImage()) {
      <div class="loading-container">
        <mat-spinner diameter="48"></mat-spinner>
        <p>{{ 'helpSupport.loadingPreview' | translate }}</p>
      </div>
    }

    @if (error) {
      <div class="error-container">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <p>{{ 'helpSupport.previewError' | translate }}</p>
      </div>
    }

    @if (isPdfOrImage() && !error && safeUrl) {
      <iframe
        [src]="safeUrl"
        class="preview-iframe"
      ></iframe>
    }

    @if (!isPdfOrImage()) {
      <div class="unsupported-container">
        <mat-icon class="unsupported-icon">insert_drive_file</mat-icon>
        <p>{{ 'helpSupport.previewNotSupported' | translate }}</p>
        <p class="unsupported-hint">{{ 'helpSupport.downloadToView' | translate }}</p>
      </div>
    }
  </div>

  <div class="preview-footer">
    <button class="close-btn-footer" (click)="onClose()">
      {{ 'common.close' | translate }}
    </button>
    <button class="download-btn" (click)="onDownload()">
      {{ 'helpSupport.download' | translate }}
    </button>
  </div>
</div>
